import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BsCheckCircleFill } from "react-icons/bs";
import logo from "../../assets/logo.PNG"; // Updated logo

const SignUp = () => {
  const [clientName, setClientName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [checked, setChecked] = useState(false);

  const [errClientName, setErrClientName] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPhone, setErrPhone] = useState("");
  const [errPassword, setErrPassword] = useState("");

  const [successMsg, setSuccessMsg] = useState("");

  const handleSignUp = (e) => {
    e.preventDefault();

    if (!clientName) setErrClientName("Enter your full name");

    if (!email) setErrEmail("Enter your email");
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email))
      setErrEmail("Enter a valid email");

    if (!phone) setErrPhone("Enter your phone number");

    if (!password) setErrPassword("Create a password");
    else if (password.length < 6)
      setErrPassword("Password must be at least 6 characters");

    if (
      clientName &&
      email &&
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email) &&
      phone &&
      password &&
      password.length >= 6 &&
      checked
    ) {
      setSuccessMsg(
        `Hello ${clientName}, welcome to BCC Mart! Your account has been created successfully.`
      );

      setClientName("");
      setEmail("");
      setPhone("");
      setPassword("");
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-center bg-gray-100">

      {/* Left panel */}
      <div className="w-1/2 hidden lgl:flex h-full text-white">
        <div className="w-[450px] h-full bg-primeColor px-10 flex flex-col gap-6 justify-center">

          <Link to="/">
            <img src={logo} alt="BCC Mart Logo" className="w-32 mb-4" />
          </Link>

          <h1 className="font-titleFont text-2xl font-semibold">
            Welcome to BCC Mart
          </h1>

          <p className="text-base text-gray-200">
            Sign up to access exclusive hypermarket deals, products & promotions.
          </p>

          <div className="flex flex-col gap-3 mt-6">

            <div className="flex items-start gap-3">
              <BsCheckCircleFill className="text-green-500 mt-1" />
              <p className="text-gray-200 text-sm">
                Fast and easy account creation.
              </p>
            </div>

            <div className="flex items-start gap-3">
              <BsCheckCircleFill className="text-green-500 mt-1" />
              <p className="text-gray-200 text-sm">
                Get updates on BCC Mart offers.
              </p>
            </div>

            <div className="flex items-start gap-3">
              <BsCheckCircleFill className="text-green-500 mt-1" />
              <p className="text-gray-200 text-sm">
                Trusted by hundreds of shoppers across the UAE.
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* Right panel */}
      <div className="w-full lgl:w-1/2 flex flex-col justify-center px-6">

        {successMsg ? (
          <div className="w-full max-w-md mx-auto text-center">
            <p className="text-green-500 font-semibold mb-6">{successMsg}</p>

            <Link to="/signin">
              <button className="w-full h-10 bg-primeColor text-white rounded-md hover:bg-black duration-300">
                Sign In
              </button>
            </Link>
          </div>
        ) : (

          <form className="w-full max-w-md mx-auto bg-white p-6 rounded-lg shadow-md flex flex-col gap-4">

            <h1 className="font-titleFont text-2xl font-semibold text-center mb-4">
              Create Your BCC Mart Account
            </h1>

            {/* Full Name */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-medium">Full Name</label>
              <input
                type="text"
                value={clientName}
                onChange={(e) => {
                  setClientName(e.target.value);
                  setErrClientName("");
                }}
                placeholder="John Doe"
                className="w-full h-10 px-3 border border-gray-400 rounded-md"
              />
              {errClientName && (
                <p className="text-red-500 text-sm">{errClientName}</p>
              )}
            </div>

            {/* Email */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-medium">Work Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrEmail("");
                }}
                placeholder="john@workemail.com"
                className="w-full h-10 px-3 border border-gray-400 rounded-md"
              />
              {errEmail && (
                <p className="text-red-500 text-sm">{errEmail}</p>
              )}
            </div>

            {/* Phone */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-medium">Phone Number</label>
              <input
                type="text"
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                  setErrPhone("");
                }}
                placeholder="056XXXXXXX"
                className="w-full h-10 px-3 border border-gray-400 rounded-md"
              />
              {errPhone && (
                <p className="text-red-500 text-sm">{errPhone}</p>
              )}
            </div>

            {/* Password */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-medium">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrPassword("");
                }}
                placeholder="Create password"
                className="w-full h-10 px-3 border border-gray-400 rounded-md"
              />
              {errPassword && (
                <p className="text-red-500 text-sm">{errPassword}</p>
              )}
            </div>

            {/* Terms */}
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={checked}
                onChange={() => setChecked(!checked)}
                className="w-4 h-4 cursor-pointer"
              />
              <p className="text-sm text-gray-700">
                I agree to the{" "}
                <span className="text-blue-600 underline cursor-pointer">
                  Terms of Service
                </span>{" "}
                and{" "}
                <span className="text-blue-600 underline cursor-pointer">
                  Privacy Policy
                </span>.
              </p>
            </div>

            {/* Button */}
            <button
              onClick={handleSignUp}
              className={`w-full h-10 rounded-md text-white ${
                checked
                  ? "bg-primeColor hover:bg-black"
                  : "bg-gray-400 cursor-not-allowed"
              } duration-300`}
              disabled={!checked}
            >
              Create Account
            </button>

            <p className="text-center text-sm">
              Already have an account?{" "}
              <Link to="/signin" className="text-blue-600 underline">
                Sign In
              </Link>
            </p>

          </form>
        )}
      </div>
    </div>
  );
};

export default SignUp;